import { SuccessView } from "../shared/components/success-view.js";

interface ModalSuccessProps {
  onResend: () => void;
  name: string;
  smsSent: boolean;
}

export function ModalSuccess({ onResend, name, smsSent }: ModalSuccessProps) {
  return <SuccessView name={name} onResend={onResend} smsSent={smsSent} />;
}
